import { render, staticRenderFns } from "./TextInvites.vue?vue&type=template&id=12cfe044&"
import script from "./TextInvites.vue?vue&type=script&lang=js&"
export * from "./TextInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports